/*
* Use this module to keep track of alert states throghout the application.
* DO NOT create additional states unless that is extremely neceessary!
* Instead, create additional keys for the "alerts" state.
* Ex: $store.getters.alerts.application
    - "application" is an attribute (key) of the unique state alerts;
    - alerts' keys will ultimately define whether or not an alert identified by <key> should be
    presented or not.
    - keys MUST be of boolean type;

  Note: This is supposed to be an ISOLATED module. That being said, please keep OUT business logic
  that doesn't directly relates to the content of this module OR that makes reference to another
  Vuex Store or Module.
*/

import {
  SET_ALERT, UNSET_ALERT,
  SET_ALERT_KEY,
} from '@/vuex/modules/alerts/types/mutations';

import {
  DEFINE_ALERTS, CLEAR_ALERTS,
  DEFINE_APPLICATION_ALERT,
} from '@/vuex/modules/alerts/types/actions';


export default {
  state: {
    alerts: null,
  },
  getters: {
    alerts: state => state.alerts,
  },
  mutations: {
    [SET_ALERT](state, alerts) {
      state.alerts = alerts || { application: true };
      localStorage.alerts = JSON.stringify(state.alerts);
    },
    [UNSET_ALERT](state) {
      state.alerts = null;
      localStorage.removeItem('alerts');
    },
    [SET_ALERT_KEY](state, payload) {
      const alerts = state.alerts;
      alerts[payload.id] = payload.enabled;
      state.alerts = alerts;
      localStorage.alerts = JSON.stringify(state.alerts);
    },
  },
  actions: {
    [DEFINE_ALERTS](context, payload) {
      context.commit(SET_ALERT, payload.alerts);
    },
    [CLEAR_ALERTS](context) {
      context.commit(UNSET_ALERT);
    },
    [DEFINE_APPLICATION_ALERT](context, payload) {
      context.commit(SET_ALERT_KEY, { id: 'application', enabled: payload.enabled });
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/alerts/index.js